import { Link } from "react-router-dom";
import { trackHubEvent } from "@/utils/hub";

const ROW = [
  { code: "PT.01", name: "Peptide Therapy", tagline: "Recovery, performance, and longevity — precisely dosed.", img: "/img/programs/program-longevity.webp", to: "/programs/peptide-therapy" },
  { code: "HO.02", name: "Hormone Optimization", tagline: "Energy, metabolism, and vitality — back in balance.", img: "/img/programs/program-hormonal.webp", to: "/programs/hormone-optimization" },
  { code: "SO.03", name: "Supplement Optimization", tagline: "Free supplement analysis with Maya — powered by Vantyx.", img: "/img/programs/program-metabolic.webp", to: "/assistants#supplements" },
];

export function ProgramRow() {
  return (
    <section className="blueprint-grid border-y border-slate-200 py-12 px-4 sm:px-6 lg:px-8" data-testid="program-row">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <p className="font-mono text-xs font-bold uppercase text-brand-red mb-2">Optimization Programs</p>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-navy">One intake unlocks every program</h2>
          </div>
          <Link
            to="/assistants#optimization-intake"
            onClick={() => trackHubEvent("intake_program_click", null, { program: "How to Begin", placement: "homepage_row" })}
            className="font-mono text-xs font-bold uppercase text-brand-red hover:text-red-800 transition-colors"
            data-testid="program-row-begin-link"
          >
            How to begin &rarr;
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {ROW.map((p) => (
            <Link
              key={p.code}
              to={p.to}
              onClick={() => trackHubEvent("intake_program_click", null, { program: p.name, placement: "homepage_row" })}
              className="group bg-white border-2 border-navy/10 overflow-hidden hover:border-brand-red/60 transition-[border-color] flex flex-col"
              data-testid={`home-program-${p.code.toLowerCase().replace(".", "-")}`}
            >
              <div className="relative overflow-hidden">
                <img src={p.img} alt={p.name} className="w-full h-44 object-cover group-hover:scale-[1.03] transition-transform duration-500" loading="lazy" />
                <span className="absolute top-3 left-3 font-mono text-[10px] font-bold text-navy bg-white/90 backdrop-blur border border-slate-200 px-2 py-1">{p.code}</span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-heading text-xl font-bold text-navy group-hover:text-brand-red transition-colors">{p.name}</h3>
                <p className="font-body text-base text-gray-600 mt-2 leading-relaxed flex-1">{p.tagline}</p>
                <span className="font-mono text-[10px] font-bold uppercase text-brand-red mt-4">Explore &rarr;</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
